import { render, staticRenderFns } from "./BtnAtualizarRecurso.vue?vue&type=template&id=50078188"
import script from "./BtnAtualizarRecurso.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarRecurso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports